<template>
  <article class="resource-list-item" @click="onClickHandler">
    <div class="card-content">
      <div class="media">
        <div class="media-left">
          <figure class="resource-image image">
            <img :src="image" :alt="title">
          </figure>
        </div>
        <div class="media-content">
          <div class="resource-type">
            <img class="resource-type-image" :src="categoryImg" :alt="category" v-if="categoryImg">
            <span class="tag is-transparent" style="float: right;">{{ category }}</span>
          </div>
          <h5 class="resource-title">{{ title }}</h5>
          <span class="resource-tag tag" :class="`is-category-${tag.id}`" v-for="(tag, index) in tags" :key="index" :style="getTagColor(tag)">{{ tag.name }}</span>
          <p>{{ description }}</p>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    category: {
      type: String,
      required: true
    },
    categoryImg: {
      type: String,
      required: false
    },
    tags: {
      type: Array,
      required: true
    },
    externalUrl: {
      type: String,
      required: false
    },
    onClick: {
      type: Function,
      default: () => {}
    }
  },

  methods: {
    onClickHandler () {
      if (this.externalUrl) {
        this.onClick(this.externalUrl)
      } else {
        this.onClick(this.id)
      }
    },

    getTagColor (tag) {
      return { 'background-color': tag.color ? tag.color : '#6b7285' }
    }
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

.resource-list-item {
  border-bottom: 1px solid lightgray;
  cursor: pointer;

  .resource-image {
    width: 8rem;
    height: 8rem;

    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .resource-title {
    margin-bottom: .5rem;
    @include text-size-l();
    font-weight: 600;
    color: $color-text-dark;
  }

  .resource-type {
    float: right;
    text-align: center;

    .tag {
      color: $color-brand-secondary;
      font-weight: $font-weight-regular;
    }

    .resource-type-image {
      max-width: 2.5rem;
    }
  }

  .resource-tag {
    margin-bottom: .5rem;
  }

  &:hover {
    background-color: $color-gray-lighter;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ResourceListItem.vue